/**
 * Executive Briefing Module Index
 * Main entry point for Executive Briefing features
 * Part 3, Phase 5 - Executive Briefing UI
 */

import React, { useEffect, useState } from 'react';
import { Tabs, Button, Space } from 'antd';
import { PlusOutlined, FileTextOutlined, HistoryOutlined } from '@ant-design/icons';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ExecutiveBriefingPage from './ExecutiveBriefingPage';
import BriefingHistory from './components/BriefingHistory';
import BriefingGenerator from './components/BriefingGenerator';

const { TabPane } = Tabs;

const ExecutiveBriefingIndex = () => {
  const { briefingId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [showGenerator, setShowGenerator] = useState(false);
  const [activeTab, setActiveTab] = useState(briefingId ? 'view' : 'history');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('generate') === '1') {
      setShowGenerator(true);
    }
  }, [location.search]);

  /**
   * Handle successful briefing generation
   */
  const handleGenerationSuccess = (briefing) => {
    console.log('[ExecutiveBriefing] Briefing generated:', briefing);
    // The BriefingGenerator will navigate to the briefing page
  };

  // If briefingId is provided, show the briefing page directly
  if (briefingId) {
    return <ExecutiveBriefingPage />;
  }

  // Otherwise, show tabs with history and option to generate
  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-ubuntu font-bold text-[#007ab9] mb-2">
            Executive Briefings
          </h1>
          <p className="text-gray-600">
            AI-powered strategic insights and cross-module analytics
          </p>
        </div>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          size="large"
          onClick={() => setShowGenerator(true)}
        >
          Generate New Briefing
        </Button>
      </div>

      {/* Tabs */}
      <Tabs activeKey={activeTab} onChange={setActiveTab} size="large">
        <TabPane
          tab={
            <span className="flex items-center gap-2">
              <HistoryOutlined />
              Briefing History
            </span>
          }
          key="history"
        >
          <BriefingHistory />
        </TabPane>
      </Tabs>

      {/* Generator Modal */}
      <BriefingGenerator
        visible={showGenerator}
        onClose={() => {
          setShowGenerator(false);
          const params = new URLSearchParams(location.search);
          if (params.has('generate')) {
            params.delete('generate');
            navigate(
              {
                pathname: location.pathname,
                search: params.toString() ? `?${params.toString()}` : ''
              },
              { replace: true }
            );
          }
        }}
        onSuccess={handleGenerationSuccess}
      />
    </div>
  );
};

export default ExecutiveBriefingIndex;
